import {Component, OnInit, Input} from '@angular/core';

@Component({
    selector: 'loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {
    @Input("loading") isLoading = true;

    constructor() {
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/loader/loader.component.ts